import(/* webpackMode: "eager" */ "/app/apps/web/app/(public)/product/procurement/page.tsx");
